import {
    createAuthStore,
} from "@mrflark/core/auth";

type SPLPermissions = {
    canTag: () => boolean;
    canDelete: () => boolean;
    canHardDelete: () => boolean;
    canManage: () => boolean;
};

export const useAuthStore = createAuthStore<SPLPermissions>((_set, get) => ({
    canTag: (): boolean => get().isAuthenticated,
    canDelete: (): boolean => get().isAdmin,
    canHardDelete: (): boolean => get().isAdmin,
    canManage: (): boolean => get().isAdmin,
}));
